import { ICheckBookData } from '@modules/accounting-and-finance/interface/check-book/check-book-interface';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: ICheckBookData[] = [];

export const ACCGCheckBookSlice = createSlice({
  name: 'accgCheckBook',
  initialState,
  reducers: {
    setACCGCheckBook: (_state, action: PayloadAction<ICheckBookData[]>) => {
      return [...action.payload];
    },
    removeACCGCheckBook: () => {
      return initialState;
    },
  },
});

export default ACCGCheckBookSlice.reducer;

export const { setACCGCheckBook, removeACCGCheckBook } =
  ACCGCheckBookSlice.actions;
